import {
  getStableItemId,
  isEligibleForDefaultSelection,
} from './itemSelectionUtils';

const isDataBreachMethod = (method) => String(method || '').includes('data_breach');

export function getDataBreachCompanionIds(
  hardInquiries = [],
  personalInfoItems = [],
  { protectedPIIds = [], excludedMatcher = null } = {}
) {
  const inquiryIds = hardInquiries
    .filter((item) => isEligibleForDefaultSelection(item, 'inquiry', { excludedMatcher }))
    .map((item) => getStableItemId(item, 'inquiry'))
    .filter(Boolean);

  const personalInfoIds = personalInfoItems
    .filter((item) => isEligibleForDefaultSelection(item, 'personal_info', { protectedPIIds, excludedMatcher }))
    .map((item) => getStableItemId(item, 'personal_info'))
    .filter(Boolean);

  return { inquiryIds, personalInfoIds };
}

export function shouldIncludeDataBreachCompanions({
  selectedMethod,
  classification,
  methodResolution,
  selectedItems,
  forceDataBreachCompanions = false,
  // When false, ignore methodResolution so resolve-methods cannot expand
  // companions and retrigger itself in a render loop.
  allowMethodResolutionCompanions = false,
} = {}) {
  if (forceDataBreachCompanions) {
    return true;
  }

  if (selectedMethod === 'data_breach' || classification === 'data_breach') {
    return true;
  }

  if ((selectedItems?.inquiries?.length || 0) > 0 || (selectedItems?.personalInfo?.length || 0) > 0) {
    return true;
  }

  if (!allowMethodResolutionCompanions) {
    return false;
  }

  const assignments = methodResolution?.item_assignments || {};
  if (Object.values(assignments).some((entry) => isDataBreachMethod(entry?.assigned_method))) {
    return true;
  }

  const groups = methodResolution?.method_groups || [];
  if (groups.some((group) => isDataBreachMethod(group?.method_key))) {
    return true;
  }

  return false;
}

export function mergeDataBreachCompanionSelection(
  selectedItems,
  hardInquiries = [],
  personalInfoItems = [],
  options = {}
) {
  if (!shouldIncludeDataBreachCompanions({ ...options, selectedItems })) {
    return selectedItems;
  }

  const { inquiryIds, personalInfoIds } = getDataBreachCompanionIds(
    hardInquiries,
    personalInfoItems,
    options
  );

  return {
    accounts: [...(selectedItems?.accounts || [])],
    inquiries: [...new Set([...(selectedItems?.inquiries || []), ...inquiryIds])],
    personalInfo: [...new Set([...(selectedItems?.personalInfo || []), ...personalInfoIds])],
  };
}

export function buildEffectiveDisputeSelection(
  selectedItems,
  hardInquiries = [],
  personalInfoItems = [],
  options = {}
) {
  return mergeDataBreachCompanionSelection(
    selectedItems,
    hardInquiries,
    personalInfoItems,
    options
  );
}
